import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * Fallback component shown while lazy-loaded pages are loading
 * Used with React.lazy() and Suspense for code splitting
 */
export default function PageSuspenseFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
}
